import { PdpSharedRingSizeDetail_detailValues as DetailValues } from './__generated__/PdpSharedRingSizeDetail_detailValues.graphql';
import { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { CurrencyProvider } from 'dibs-buyer-layout/exports/CurrencyProvider';

type Props = {
    detailValues: DetailValues;
};

const PdpSharedRingSizeDetailComponent: FC<Props> = ({ detailValues }) => {
    return (
        <CurrencyProvider
            render={({ currency }: { currency: string }) => {
                const ringSizeUnit = currency === 'USD' ? 'US' : 'MM';
                const ringSizeDisplay = detailValues?.[0]?.ringSizes?.find(
                    size => size?.unit === ringSizeUnit
                )?.value;

                return <>{ringSizeDisplay}</>;
            }}
        />
    );
};

export const PdpSharedRingSizeDetail = createFragmentContainer(PdpSharedRingSizeDetailComponent, {
    detailValues: graphql`
        fragment PdpSharedRingSizeDetail_detailValues on PdpDetailValueInterface
        @relay(plural: true) {
            detailKey
            ... on PdpDetailRingSize {
                ringSizes {
                    unit
                    value
                }
            }
        }
    `,
});
